<div class="contact py-5" id="contact">
  <div class="container d-flex flex-column align-items-center gap-4">
    <div class="row w-100 gap-4">
      <div class="col-12 d-flex flex-column align-items-center gap-2">
        <h2 class="text-light fw-bold">Get In Touch</h2>
        <div class="underline"></div>
      </div>
      <div class="col-12">
        <p class="text-center contact-subtitle">
          Have an idea, project, or collaboration in mind? I’m always open to new opportunities and meaningful conversations. Just fill out the form below — I’ll get back to you promptly!
        </p>
      </div>
    </div>
    <div class="row contact-form w-100">
      <div class="basic-info col-md-6 d-flex flex-column gap-4">
        <span class="text-white fs-4 fw-bold">Contact Information</span>
        @for (infoItem of info; track $index) {
        <div class="d-flex gap-3">
          <img
            class="icon"
            src="assets/images/svg/{{ infoItem.icon }}.svg"
            alt="icon"
          />
          <div class="info-section d-flex flex-column gap-1">
            <span class="text-white title fw-bold">{{ infoItem.title }}</span>
            <span class="text-white">{{ infoItem.desc }}</span>
          </div>
        </div>
        }
        <div class="follow-section d-flex flex-column gap-3">
          <h5 class="text-white m-0">Follow Me</h5>
          <div class="socials d-flex gap-3">
            @for (social of socials; track $index) {
            <a [href]="social.url" target="_blank">
              <img src="assets/images/{{ social.icon }}" alt="social-icon" srcset="" />
            </a>
            }
          </div>
        </div>
      </div>
      <div class="send-mssg col-md-6">
        <span class="text-white fs-4 fw-bold mb-4">Send a Message</span>
        <form
          [formGroup]="contactForm"
          class="d-flex flex-column gap-4"
          (ngSubmit)="sendMail()"
        >
          <div class="top-fields d-flex gap-3">
            <div class="name">
              <label class="text-tertiary" for="name">Name</label>
              <input
                autocomplete="off"
                class="w-100"
                type="text"
                formControlName="name"
                id="name"
                placeholder="John Doe"
              />
              @if (contactForm.controls['name'].invalid &&
              contactForm.controls['name'].touched) {
              <span class="error-mssg">Name is required!</span>
              }
            </div>
            <div class="email">
              <label class="text-tertiary" for="email">Email</label>
              <input
                autocomplete="off"
                class="w-100"
                type="email"
                formControlName="email"
                id="email"
                placeholder="john.doe@example.com"
              />
              @if (contactForm.controls['email'].invalid &&
              contactForm.controls['email'].touched) {
              <span class="error-mssg">{{
                contactForm.controls["email"].hasError("email")
                  ? "Email is incorrect!"
                  : "Email is required!"
              }}</span>
              }
            </div>
          </div>
          <div class="subject">
            <label class="text-tertiary" for="subject">Subject</label>
            <input
              autocomplete="off"
              class="w-100"
              type="text"
              formControlName="subject"
              id="subject"
              placeholder="Project Inquiry"
            />
            @if (contactForm.controls['subject'].invalid &&
            contactForm.controls['subject'].touched) {
            <span class="error-mssg">Subject is required!</span>
            }
          </div>
          <div class="message d-flex flex-column">
            <label class="text-tertiary" for="message">Message</label>
            <textarea
              formControlName="message"
              id="message"
              rows="5"
              placeholder="I'm interested in discussing a potential project..."
            ></textarea>
            @if (contactForm.controls['message'].invalid &&
            contactForm.controls['message'].touched) {
            @if(!contactForm.controls['message'].value?.length){
            <span class="error-mssg">Message is required!</span>
            } @else {
            <span class="error-mssg">{{
              contactForm.controls["message"].hasError("maxLength")
                ? "Opps! Max Limit Reached."
                : "Please elaborate your message!"
            }}</span>
            } }
          </div>
          <!-- ✅ Google reCAPTCHA Widget -->
          @if(isBrowser){
          <re-captcha
            #recaptchaRef
            [siteKey]="RE_CAPTCHA_SITE_KEY"
            [theme]="'dark'"
            (resolved)="onCaptchaSuccess($event)"
          ></re-captcha>
          }

          @if (!sendingMail) {
            <button 
              type="submit"
              class="submit-btn text-white"
              [disabled]="contactForm.invalid && !captchaToken"
              [style]="{ cursor: contactForm.valid ? 'pointer' : 'not-allowed' }"
            >
              <img src="assets/images/svg/send.svg" alt="send" srcset="" />
              Send Message
            </button>
          } @else {
            <span class="submit-btn text-white">Sending...</span>
          }
        </form>
      </div>
    </div>
  </div>
</div>
